import { useEffect, useRef } from "react";
import gsap from "gsap";

let ctl = null;

export function TransitionOverlay() {
  const ref = useRef(null);
  useEffect(() => {
    ctl = ref.current;
    return () => {
      ctl = null;
    };
  }, []);
  return (
    <div
      ref={ref}
      className="pointer-events-none fixed inset-0 z-[200] flex items-center justify-center bg-ink"
      style={{ clipPath: "inset(100% 0 0 0)" }}
      data-testid="page-transition-overlay"
      aria-hidden="true"
    >
      <div className="t-mark flex items-baseline gap-2 opacity-0">
        <span className="font-display text-5xl font-black tracking-tight">OA</span>
        <span className="font-mono text-[10px] tracking-[0.3em] text-smoke">HOLDING</span>
      </div>
    </div>
  );
}

export function transitionTo(navigate, path) {
  if (!ctl || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    navigate(path);
    window.scrollTo(0, 0);
    return;
  }
  const mark = ctl.querySelector(".t-mark");
  gsap
    .timeline()
    .set(ctl, { clipPath: "inset(100% 0 0 0)" })
    .to(ctl, { clipPath: "inset(0% 0 0 0)", duration: 0.45, ease: "power3.inOut" })
    .to(mark, { opacity: 1, duration: 0.18 }, "-=0.15")
    .add(() => {
      navigate(path);
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      window.scrollTo(0, 0);
    })
    .to(mark, { opacity: 0, duration: 0.18 }, "+=0.12")
    .to(ctl, { clipPath: "inset(0 0 100% 0)", duration: 0.5, ease: "power3.inOut" }, "-=0.08")
    .set(ctl, { clipPath: "inset(100% 0 0 0)" });
}
